/** Frame rate every topic timeline compiles at (live player, bake, gate). */
export const TOPIC_TIMELINE_FPS = 30;

/** Cover / close length when they have no narration and no speakable text. */
export const TOPIC_BOOKEND_MIN_MS = 3_000;

/** `Math.round(ms * fps / 1000)`; 0 for non-finite input or fps. */
export function msToFrame(
	ms: number,
	fps: number = TOPIC_TIMELINE_FPS,
): number {
	if (!Number.isFinite(ms) || !Number.isFinite(fps) || fps <= 0) {
		return 0;
	}
	return Math.max(0, Math.round((ms * fps) / 1000));
}

/** Inverse of {@link msToFrame}. */
export function frameToMs(
	frames: number,
	fps: number = TOPIC_TIMELINE_FPS,
): number {
	if (!Number.isFinite(frames) || !Number.isFinite(fps) || fps <= 0) {
		return 0;
	}
	return Math.round((frames * 1000) / fps);
}
